//console.log('facets.js---------')
class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));
    console.log('facets.js-----------------')

    //this.querySelectorAlccl('details').forEach((el) => {
      //new Accordion(el);
    //});
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    //document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }

    sections.forEach((section) => {
      if(searchParams == 'filter.v.availability=1'){
        searchParams = ''
      } else if(searchParams.length > 1 && !searchParams.includes('filter.v.availability=1')){
        searchParams += '&filter.v.availability=1';
      }
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      //console.log('searchParams')
      //console.log(searchParams)
      
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    expandableAccordions();

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        FacetFiltersForm.renderFilterCount(html);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    FacetFiltersForm.renderFilterCount(html);
  }

  static renderProductGridContainer(html) {
    //console.log('html')
    //console.log(html)
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    const container = document.getElementById('ProductCount');
    container.innerHTML = count;
    container.classList.remove('loading');
  }

  static renderFilterCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementsByClassName('total_active_values')[0].innerHTML;
    const container = document.getElementsByClassName('total_active_values')[0];
    
    const queryParams = new URLSearchParams(window.location.search);
    if(queryParams.has('filter.p.m.fog.gender')){
      //count--;
    }
    container.innerHTML = count;

    //container.classList.remove('loading');
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements = parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter');
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter((element) => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    setTimeout(() => {
      const promoBanners = document.querySelectorAll('.promo-banner');
      if (promoBanners[0] != null) {
        promoBanners.forEach((el) => {
          el.classList.add('scroll-animation--active');
        });
      }
    }, 1000);

    document.querySelectorAll('facet-filters-form details').forEach((el) => {
      new Accordion(el);
    });
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];

      sortFilterForms.forEach((form) => {
        if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();
class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('.field__input').forEach((element) =>
      element.addEventListener('change', this.onRangeChange.bind(this))
    );
    this.setMinAndMaxValues();
    this.querySelectorAll('.price-range__slider input').forEach((element) =>
      element.addEventListener('change', this.setSliderValues.bind(this))
    );
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('.field__input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    const ranges = this.querySelectorAll('.price-range__slider input');

    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));

    ranges[0].value = minInput.value;
    ranges[1].value = maxInput.value;

    //ranges[0].value = minInput.innerHTML;
    //ranges[1].value = maxInput.innerHTML;
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }

  setSliderValues() {
    const ranges = this.querySelectorAll('.price-range__slider input');
    let range1 = roundToNearestFive(Number(ranges[0].value));
    let range2 = roundToNearestFive(Number(ranges[1].value));
    const inputs = this.querySelectorAll('.field__input');

    if (range1 > range2) {
      let tmp = range2;
      range2 = range1;
      range1 = tmp;
    }

    inputs[0].value = range1;
    inputs[1].value = range2;
    //inputs[0].innerHTML = range1;
    //inputs[1].innerHTML = range2;
  }
}

function roundToNearestFive(num) {
  return Math.round(num / 5) * 5;
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    const modalBtn = this.querySelector('.filter-modal__close');

    if (modalBtn) {
      modalBtn.addEventListener('click', (el) => {
        el.target.closest('details').querySelector('summary').click();
      });
    }

    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);

/*
Array.from(document.getElementsByClassName('price-range-custom')[0].getElementsByTagName('label')).forEach((label, i) => {

  label.addEventListener('click', e => {
    console.log('click')
    let changeEvent = new Event('change');
    if(i === 0){
      //document.getElementById('Filter-Price-GTE').value = 0;
      //document.getElementById('Filter-Price-LTE').value = 25;

      //document.getElementsByClassName('price-range__slider')[0].getElementsByTagName('input')[0].value = 0
      document.getElementsByClassName('price-range__slider')[0].getElementsByTagName('input')[1].value = 25

    }

    //document.getElementById('Filter-Price-GTE').dispatchEvent(changeEvent);
    //document.getElementById('Filter-Price-LTE').dispatchEvent(changeEvent);

    document.getElementsByClassName('price-range__slider')[0].getElementsByTagName('input')[1].dispatchEvent(changeEvent);
    //document.getElementsByClassName('price-range__slider')[0].getElementsByTagName('input')[1].value = 25
  })

}) 
*/



// Select the node that will be observed for mutations
const targetNode = document.getElementById("FacetFiltersForm");

// Options for the observer (which mutations to observe)
const config = { attributes: true, childList: true, subtree: true };

// Callback function to execute when mutations are observed
const callback = (mutationList, observer) => {
  for (const mutation of mutationList) {
    if (mutation.type === "childList") {
      //console.log("A child node has been added or removed.");
    } else if (mutation.type === "attributes") {
      //console.log(`The ${mutation.attributeName} attribute was modified.`);
    }
    //setTimeout(()=>{
      hideEmptyOptions();
    //},1000);
  }
};

// Create an observer instance linked to the callback function
const observer = new MutationObserver(callback);

// Start observing the target node for configured mutations
observer.observe(targetNode, config);

setTimeout(()=>{
  hideEmptyOptions();
},1000)

function hideEmptyOptions(){
  [...document.getElementsByClassName('drawer__tab-content--filters')[0].getElementsByClassName('filter__item')].forEach(el => {
    if(el.classList.contains('filter--price')){
      return;
    }
    if(!el.getElementsByClassName('facets__list')[0].innerHTML.includes('<li>')){
      //el.style.opacity = "0.1"
      //el.style.display = "none"
    } else {
      //el.style.removeProperty('display');
      //el.style.removeProperty('opacity');
    }

    let facetCount = el.getElementsByClassName('facets__list')[0].getElementsByTagName('li').length;


    if(!el.classList.contains('filter--footwear-sizes')){
      if(facetCount === 0){
        //el.style.opacity = "0.1"
        el.style.display = "none"
      } else if(facetCount === 1){
        let onlyFacet = el.getElementsByClassName('facets__list')[0].getElementsByTagName('li')[0].getElementsByTagName('input')[0];
        el.style.display = "none"
        /*
        if(!onlyFacet.checked){
        el.style.display = "none"
        //el.style.opacity = "0.1"
        } else {
          el.style.removeProperty('display');
          //el.style.removeProperty('opacity');
        }
        */
      } else {
        el.style.removeProperty('display');
        //el.style.removeProperty('opacity');
      }
    } else {

      //el.style.opacity = "0.1"
      if(document.getElementsByClassName('filter--product-type').length > 0 && document.getElementsByClassName('filter--footwear-sizes').length > 0) {
        let productType = document.getElementsByClassName('filter--product-type')[0];
        [...productType.getElementsByTagName('input')].forEach(input =>{
          if(input.value == 'footwear' && input.checked){
            //document.getElementsByClassName('filter--footwear-sizes')[0].style.removeProperty('opacity');
            document.getElementsByClassName('filter--footwear-sizes')[0].style.removeProperty('display');
          }
          if(input.value == 'footwear' && !input.checked && !window.location.pathname.includes('footwear')){
            
            //document.getElementsByClassName('filter--footwear-sizes')[0].style.opacity = "0.1"
            document.getElementsByClassName('filter--footwear-sizes')[0].style.display = "none"
          }
        })
      }

    }
    
  })
  let checkboxArr = [...document.getElementsByClassName('facets__checkbox')];
  checkboxArr.forEach(el => {
    if(el.hasAttribute('checked') && !el.checked){
      el.removeAttribute('checked')
    }
  })
}


const topFilterType = 'product-type';
//const topFilterType = 'gender';

function renderTopFilters(){
  const queryParams = new URLSearchParams(window.location.search);

  if(document.getElementsByClassName(`filter--${topFilterType}`).length > 0){

    let inputArr = [...document.getElementsByClassName(`filter--${topFilterType}`)[0].getElementsByTagName('input')];

    if(queryParams.size > 0){
      fetch(window.location.pathname)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;

        const filters = new DOMParser().parseFromString(html, 'text/html').getElementsByClassName('filter--product-type')[0];
        //console.log('filters')
        //console.log(filters)

        inputArr = [...filters.getElementsByTagName('input')];
      });
    }

    if(inputArr.length < 1) return;

    let html = '';
    html += `<a href="${window.location.pathname}" class="top-filter" data-filter="All">All</a>`;
    inputArr.forEach(input => {
      let title = input.value;
      html += `<a href="${window.location.pathname}?${input.name}=${input.value}" class="top-filter" data-filter="${input.value}">${title}</a>`;
    })
    document.getElementsByClassName('top-filters')[0].innerHTML = html;

    const filterKey = inputArr[0].name; 
    const topFilterArr = [...document.getElementsByClassName('top-filter')];

    topFilterArr.forEach(el => {
      // update active class 
      if(queryParams.has(`${filterKey}`)){
        let curr = queryParams.get(filterKey);
        if(curr == el.dataset.filter){
          el.classList.add('active-top-filter');
        } else {
          el.classList.remove('active-top-filter');
        }
      } else {
        if(el.dataset.filter == 'All'){
          el.classList.add('active-top-filter');
        }
      }
    })
  }
}

//renderTopFilters();


let lastScrollTop = 0;

window.addEventListener("scroll", (e) => { 
   let st = window.pageYOffset; 
   if (st > lastScrollTop && st - lastScrollTop > 2) {
   //if (st > lastScrollTop) {
      // downscroll
      document.getElementsByTagName('body')[0].classList.add('scrolling-down');
   } else if (st < lastScrollTop && lastScrollTop - st > 2) {
   //} else if (st < lastScrollTop) {
    document.getElementsByTagName('body')[0].classList.remove('scrolling-down');
      // upscroll code
   } // else was horizontal scroll
   lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
});

(()=>{
  window.navigation.addEventListener("navigate", (event) => {
    setTimeout(()=>{
      //renderTopFilters();
    }, 500)
    //console.log('location changed!');
  })
})()


function expandableAccordions(){
  //console.log('run expandable');

  setTimeout(()=>{
    document.querySelectorAll(".expandable-title--facets").forEach(function(element) {
      element.addEventListener('click', function(e) {
        //console.log('expandable', e);
        e.preventDefault();
        
        const expandableText = this.closest(".expandable-text");

        if (expandableText.classList.contains("active")) {
          expandableText.classList.remove("active");
          e.target.setAttribute('aria-expanded', 'false');
          setTimeout(() => {
            const content = expandableText.querySelector('.expandable-content');
            if (content) content.style.display = 'none';
          }, 200);
        } else {
          // Remove active class from siblings
          //const parent = expandableText.parentElement;
          //if (parent) {
            //parent.querySelectorAll(".expandable-text.active").forEach(function(sibling) {
              //sibling.classList.remove("active");
            //});
          //}
          
          expandableText.classList.add("active");
          e.target.setAttribute('aria-expanded', 'true');
          setTimeout(() => {
            const content = expandableText.querySelector('.expandable-content');
            if (content) content.style.display = 'block';
          }, 200);
        }
      });
    });
  }, 1000)
}

expandableAccordions();